import { gql } from "@stadium/services/apollo-client/server";

export const STORE_CATALOG_CACHE = gql`
  fragment StoreCatalogCache on Store {
    id
    workingOnFallback
    parentId
    cloningInProgress
    showLoader
    catalogCache {
      enableTaxonIds
      disableTaxonIds
      enabledProductIds
      activatedStoreProductIds: activateProductIds
      disabledStoreProductIds: deactivateProductIds
    }
  }
`;
